const supported = new Set(['pt', 'es', 'en']);

export function deviceInterfaceLanguage(preferences) {
  const devicePreferences = preferences || (typeof navigator !== 'undefined' ? navigator.languages || [navigator.language] : []);
  for (const preference of devicePreferences) {
    const iso = String(preference || '').toLowerCase().split(/[-_]/)[0];
    if (supported.has(iso)) return iso;
  }
  return 'en';
}
